<template>
  <v-layout row wrap class="candidate additional-details">
    <v-flex xs12><v-divider /></v-flex>

    <v-flex class="pt-4">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex xs12 :md6="sectionCount > 1" d-flex v-if="showAchievements">
            <v-card flat>
              <div class="subheading text-xs-center py-1" :class="themes.client.light.secondary">
                Achievements
              </div>
              <v-card-text class="pb-0" :class="{ 'text-xs-center': sectionCount === 1 }">
                <div v-for="(section, key) in achievements" :key="`achievement-${key}`">
                  <v-tooltip
                    v-for="(info, i) in section"
                    :key="`achievement-info-${key}${i}`"
                    max-width="30%"
                    top
                  >
                    <div slot="activator" style="display: table; cursor: pointer;">
                      <div class="pr-3" style="display: table-cell; vertical-align: middle;">
                        <v-icon>mdi-check-circle</v-icon>
                      </div>
                      <div style="display: table-cell; vertical-align: middle;">
                        <div>{{ info.title }}</div>
                        <div class="caption" :class="themes.client.light.mutedText">
                          {{ new Date(info.achievedAt) | date('yyy') }}
                        </div>
                      </div>
                    </div>
                    <span>{{ info.description }}</span>
                  </v-tooltip>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 :md6="sectionCount > 1" d-flex v-if="showSkillsAndExpertise">
            <v-card flat>
              <div class="subheading text-xs-center py-1" :class="themes.client.light.secondary">
                Skills &amp; Expertise
              </div>
              <v-card-text class="pb-0" :class="{ 'text-xs-center': sectionCount === 1 }">
                <div
                  v-for="(section, key) in skillsAndExpertise"
                  :key="`skill-${key}`"
                  class="pb-3"
                >
                  <template v-for="(info, i) in section">
                    <v-tooltip
                      v-if="key === 'behavioralCompetencies'"
                      :key="`skill-info-${key}${i}`"
                      max-width="30%"
                      top
                    >
                      <v-chip small label slot="activator"> {{ info.name }} </v-chip>
                      <span>{{ info.description }}</span>
                    </v-tooltip>
                    <v-chip small label v-else :key="`skill-chip-${key}${i}`">
                      {{ info }}
                    </v-chip>
                  </template>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 :md6="sectionCount === 2" d-flex v-if="showInterestsAndAffiliations">
            <v-card flat>
              <div class="subheading text-xs-center py-1" :class="themes.client.light.secondary">
                Interests, Clubs &amp; Societies
              </div>
              <v-card-text class="pb-0" :class="{ 'text-xs-center': sectionCount !== 2 }">
                <div
                  class="pb-3"
                  v-for="(section, key) in interestsAndAffiliations"
                  :key="`skill-${key}`"
                >
                  <template v-for="(info, i) in section">
                    <v-chip
                      small
                      label
                      v-if="key !== 'affiliations'"
                      :key="`not-affiliations-chip-${key}${i}`"
                    >
                      {{ info }}
                    </v-chip>
                    <v-tooltip
                      top
                      max-width="30%"
                      :key="`affiliations-info-${key}${i}`"
                      class="pointer"
                      v-else
                    >
                      <v-chip small label slot="activator"> {{ info.name }} </v-chip>
                      <span>{{ info.position }}</span>
                    </v-tooltip>
                  </template>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: { profile: Object },

  computed: {
    sectionCount() {
      return (
        Number(this.showAchievements) +
        Number(this.showSkillsAndExpertise) +
        Number(this.showInterestsAndAffiliations)
      )
    },

    showAchievements() {
      return Object.keys(this.achievements).some(key => this.achievements[key].length > 0)
    },

    showSkillsAndExpertise() {
      return Object.keys(this.skillsAndExpertise).some(
        key => this.skillsAndExpertise[key].length > 0
      )
    },

    showInterestsAndAffiliations() {
      return Object.keys(this.interestsAndAffiliations).some(
        key => this.interestsAndAffiliations[key].length > 0
      )
    },

    achievements() {
      return this.fillFromProfile(['achievements'])
    },

    skillsAndExpertise() {
      return this.fillFromProfile([
        'behavioralCompetencies',
        'technicalCompetencies',
        'professionalTools',
      ])
    },

    interestsAndAffiliations() {
      return this.fillFromProfile(['affiliations', 'interests'])
    },
  },

  methods: {
    fillFromProfile(sections) {
      return sections.reduce((acc, section) => {
        if (this.profile[section] && this.profile[section][0]) {
          acc[section] = this.profile[section]
          return acc
        }
        return acc
      }, {})
    },
  },
}
</script>

<style>
.client.candidate.additional-personal-details .pointer {
  cursor: pointer;
}
.client.candidate.additional-personal-details .d-table {
  display: table;
}
.client.candidate.additional-personal-details .d-cell {
  display: table;
}
</style>
